const mutations = {
    add(state, object) {
        state.items.push(object);
    }
};

export default mutations;